import isNumber from 'lodash-es/isNumber';

function getRatio(name: string | number = null, defaultRatio: number = 1): number {
    if (name === null) {
        return defaultRatio;
    }
    if (isNumber(name)) {
        return name;
    }
    const ratios = {
        square: 1,
        // horizontal: 5 / 4,
        horizontal: 4 / 3,
        vertical: 4 / 5,
        micromag: 4 / 6,
        wide: 16 / 9,
    };
    const [ratioName, double = null] = name.split('_');
    return ratios[ratioName] * (double === 'double' ? 0.5 : 1);
}

export default getRatio;
